import { Heading, RadioGroup, Span } from "@icg360/design-system";

import { MultiStepFormLayout } from "components/multi-step-form-layout";
import { IN_GROUND_POOL_STEP_COUNT } from "consts";
import { useMultiStepFormState } from "hooks/use-multi-step-form-state";

import {
  PropertyUpdatePoolContext,
  type PropertyUpdatePoolContextState,
} from ".";
import styles from "./property-update-pool.module.scss";

export const PoolFence = () => {
  const { formNavigate, state, setFields } =
    useMultiStepFormState<PropertyUpdatePoolContextState>(
      PropertyUpdatePoolContext,
    );
  const disableNext =
    !state?.poolFence ||
    (state?.poolFence === "Yes" &&
      (!state?.fenceFourFeet || !state?.fenceLockingGate));

  return (
    <MultiStepFormLayout
      step={2}
      totalSteps={IN_GROUND_POOL_STEP_COUNT}
      heading="Is your pool fenced?"
      buttonProps={{
        primary: {
          disabled: disableNext,
          path: "../board-slide",
          text: "Next",
        },
        cancel: { path: "/my/property" },
        formNavigate,
      }}
    >
      <RadioGroup
        aria-label="Pool fence options"
        className={styles.radioGroupDS}
        defaultValue={state?.poolFence}
        onChange={(value: "Yes" | "No") => setFields({ poolFence: value })}
      >
        <RadioGroup.Card title="Yes" value="Yes" />
        <RadioGroup.Card title="No" value="No" />
      </RadioGroup>
      <Span color="quiet">
        <Span bold>Pool safety: </Span>Secure fencing{" "}
        <Span bold>around the perimeter of your pool</Span> can help prevent
        accidents.
      </Span>
      {state?.poolFence === "Yes" ? (
        <>
          <Heading size="lg">Is the fence at least 4 feet tall?</Heading>
          <RadioGroup
            aria-label="Pool fence height options"
            className={styles.radioGroupDS}
            defaultValue={state?.fenceFourFeet}
            onChange={(value: "Yes" | "No") =>
              setFields({ fenceFourFeet: value })
            }
          >
            <RadioGroup.Card title="Yes" value="Yes" />
            <RadioGroup.Card title="No" value="No" />
          </RadioGroup>

          <Heading size="lg">Does the fence have a locking gate?</Heading>
          <RadioGroup
            aria-label="Pool fence lock options"
            className={styles.radioGroupDS}
            defaultValue={state?.fenceLockingGate}
            onChange={(value: "Yes" | "No") =>
              setFields({ fenceLockingGate: value })
            }
          >
            <RadioGroup.Card title="Yes" value="Yes" />
            <RadioGroup.Card title="No" value="No" />
          </RadioGroup>

          <Span color="quiet">
            <Span bold>Fencing: </Span>A fence height of{" "}
            <Span bold>at least 4 feet</Span> with a{" "}
            <Span bold>locking gate</Span> is recommended for pool safety.
          </Span>
        </>
      ) : null}
    </MultiStepFormLayout>
  );
};
